
import { classNames } from 'primereact/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../Store';
import styles from './landingpage.module.scss';

export default function LandingPageOffice() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.authSlice.auth);

    useEffect(() => {
    }, [])


    return (
        <>
            <div className="container">

                <h3>{t('deTranslation.landingPageOffice.titel')}</h3>

                <div className={styles.cardContainer} >

                    <div className={"card " + styles["landingPageCard"]} onClick={() => navigate("/auftrag/")}>
                        <span className={styles.landingPageCardSpan}>
                            Aufträge
                        </span>
                    </div>

                    <div className={"card " + styles["landingPageCard"]} onClick={() => navigate("/ticket/")}>
                        <span className={styles.landingPageCardSpan}>
                            Tickets
                        </span>
                    </div>

                    <div className={"card " + styles["landingPageCard"]} onClick={() => navigate("/neuerauftrag")}>
                        <span className={styles.landingPageCardSpan}>
                            Neuer Auftrag
                        </span>
                    </div>

                </div>
            </div>

        </>
    );
}
